if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('#ajaxifyModal');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (target.classList.contains("is-visible")) {
                console.log("Cart opened");
                
                function reloadBssScript() { 
// Tìm thẻ script cũ
const oldScript = document.querySelector('script[src$="bss-b2b-v3.js"]');
if (oldScript) oldScript.remove(); 
// xóa nó khỏi DOM

// Tạo thẻ script mới 
const newScript = document.createElement('script'); 
newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-v3.js';

// Khi tải xong thì log lại (không bắt buộc) 
newScript.onload = () => console.log('Đã reload bss-b2b-v3.js');

// Gắn vào body (hoặc head đều được)
 document.body.appendChild(newScript); }

// Gọi hàm để reload script 
reloadBssScript(); 
            }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }, 300);
}
